import Config from 'config/config';

import { isEmpty } from 'lodash';

import { setEntities } from 'redux/actions/qt_endpoint';
import { authorizedFetch, reportAndDisplayError } from './utils';

import { normalize, route } from './schemas';

const index = function ({ routeIds }) {
  return (dispatch, getState) => {
    const options = {
      method: 'GET',
    };

    const url = new URL(`${Config.quickTravelURL}/api/routes`);

    routeIds.forEach((routeId) => {
      url.searchParams.append('ids[]', routeId);
    });

    return authorizedFetch(dispatch, getState, {
      url,
      options,
    })
      .then((jsonData) => {
        if (isEmpty(jsonData)) {
          return { entities: { routes: {} } };
        }

        return normalize(jsonData, [route]);
      })
      .then((normalizedData) => {
        const { entities } = normalizedData;

        dispatch(setEntities({ entities }));
      })
      .catch((error) => {
        dispatch(reportAndDisplayError(error));
      });
  };
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { index };
